var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"card",class:{
  'card--pointed': _vm.pointed,
  'card--vertical': _vm.isVertical,
  'card--no-shadow': _vm.isNoShadow
}},[_c('div',{staticClass:"card__title"},[_vm._t("card-title")],2),_vm._t("card-logo"),_c('div',{staticClass:"card__content"},[_vm._t("default")],2),_vm._t("card-footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }